import React, {useState} from "react";
import {FaCircle} from "react-icons/fa";
import Pallet from "../../http_request/Model/pallet/Pallet";
import {toast} from "react-toastify";
import {getAgainHandler} from "../../store/TableRedux/TableRedux";
import {useDispatch} from "react-redux";
import {Button} from "antd";

const DrawerColumn = (selectedLocation, id) => {
    console.log(selectedLocation)
    const [selectedPalletId, setSelectedPalletId] = useState();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const ReqEntry = (rowData) => {
        setSelectedPalletId(rowData.palletId)
        const values = {
            "palletId": rowData.palletId,
            "rowId": id,
            "isExit": true
        }
        // ProductLine: Cookies.get('ProductLine')
        Pallet.request({
            beforeSend: () => {
                setLoading(true)
            }, success: () => {
                toast.success('تغییرات با موفقیت اعمال شد.');
                dispatch(getAgainHandler())
            }, error: (error) => {
                toast.error(error?.data?.message);
            }, final: () => {
                setLoading(false)

            },


        }).palletWarehouseEntry(values);
    }
    const columns = [
        {

            title: 'جایگاه', dataIndex: 'counter', key: 'counter',
        },

        {
            title: ' شناسه کالا',

            dataIndex: 'palletId', key: 'palletId',
        }, {
            title: 'کالا', dataIndex: 'product', key: 'product',
        }, 
		// {
            // title: 'خط تولید', dataIndex: 'productLine', key: 'productLine',


        // },

        {
            title: 'تعداد کالا', dataIndex: 'numberPerPallet', key: 'numberPerPallet'
        },
		// {
            // title: 'ق.ت', dataIndex: 'manufacturerPriceRials', key: 'manufacturerPriceRials',
        // },
		{
            title: 'قیمت کالا', dataIndex: 'consumerPriceRials', key: 'consumerPriceRials',
        }, 
		{
            title: ' وضعیت', className: "hidden lg:table-cell", dataIndex: 'qcStatus', key: 'qcStatus',
        }, 
		// {
            // title: '  تاریخ تولید', dataIndex: 'dateOfManufacture', key: 'dateOfManufacture',
        // }, {
            // title: 'تاریخ انقضا', dataIndex: 'expireDate', key: 'expireDate',
        // },

        {

            title: 'جا بجایی', dataIndex: 'allowLoadId', key: 'allowLoadId', render: (item) => {
                return <div>
                    {!item && <FaCircle color='red'/>}


                </div>

            }
        }, {

            title: 'خروج',
            className: 'cell-fix-left',
            fixed: 'right',
            dataIndex: 'allowLoadId',
            key: 'allowLoadId',
            render: (item, row) => {
                return <Button className="defBtn blueBtn"
                               loading={selectedPalletId === row.palletId && loading} onClick={() => {
                    ReqEntry(row)
                }}>خروج</Button>

            }
        },


    ];
    return [columns];
};

export default DrawerColumn;